// src/queries/calendarApiConfig.js

import { STALE_TIME, GC_TIME } from "@/queries/queryTimeConfig";

/**
 * CALENDAR API CONFIGURATION
 * Uses pms-api REST endpoints for inventory calendar data.
 */
export const calendarConfig = {
  getCalendarData: {
    key: "getCalendarData",
    url: "/api/v1/inventory/calendar",
    method: "GET",
    options: {
      staleTime: STALE_TIME.LOW_LATENCY,
      gcTime: GC_TIME.NORMAL,
      refetchOnWindowFocus: true,
      refetchInterval: 30_000,
      placeholderData: (previousData) => previousData,
      refetchIntervalInBackground: false,
      refetchOnMount: false,
    },
  },
};
